import {useMutation} from '@apollo/react-hooks';

import type {
    FormNextStepsNutshellNotificationSet as FormNextStepsNutshellNotificationSetMutation,
    FormNextStepsNutshellNotificationSetVariables as FormNextStepsNutshellNotificationSetMutationVariables,
} from 'nutshell-graphql-types';

import NEXT_STEPS_NUTSHELL_NOTIFICATION_SET from '../mutations/set-next-steps-nutshell-notification.graphql';

export function useSetNextStepsNutshellNotification(): (arg1: {
    variables: FormNextStepsNutshellNotificationSetMutationVariables;
    onUpdateSuccess: (client?: any, mutationResults?: any) => void;
}) => Promise<any> {
    const [setNextStepsNutshellNotification] = useMutation<
        FormNextStepsNutshellNotificationSetMutation,
        FormNextStepsNutshellNotificationSetMutationVariables
    >(NEXT_STEPS_NUTSHELL_NOTIFICATION_SET);

    return (input: {
        variables: FormNextStepsNutshellNotificationSetMutationVariables;
        onUpdateSuccess: (client?: any, mutationResults?: any) => void;
    }) => {
        return setNextStepsNutshellNotification({
            variables: input.variables,
            update: (proxy, mutationResults) => {
                input.onUpdateSuccess(proxy, mutationResults);
            },
        });
    };
}
